import styled from 'styled-components';

export const LabelToggle = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ToggleContainer = styled.div<{ size?: 'sm' | 'md' }>`
  margin-top: ${(props) => (props.size === 'sm' ? '6px' : 0)};
`;

export const Label = styled.div`
  padding: 0 20px;
`;

export const Description = styled.p``;
